import contactImg from "../../assets/images/base/text.jpg";
import eLogo from "../../assets/images/base/eita.png";
import locLogo from "../../assets/images/base/loc.png";
import map from "../../assets/images/base/map1.png";
import { MdPhoneInTalk } from "react-icons/md";
import { NavLink } from "react-router-dom";

export default function ContactUs() {
  return (
    <div className="contact-us">
      <img src={contactImg} className="w-100" />
      <div className="d-flex content">
        <div className="w-50  d-flex flex-column">
          <div className="d-flex flex-column flex-grow-1 phone justify-content-end">
            {/* <span className=" my-1">
              <div>
                <MdPhoneInTalk className="me-2" />
                مدیریت
              </div>
              <div className="mt-2">09129353940 - 09111753940</div>
            </span> */}

            <span className=" my-1">
              <div>
                <MdPhoneInTalk className="me-2" />
                <span style={{ fontWeight: "bold", fontSize: 20 }}>فروش</span>
              </div>
              <div className="mt-2" style={{ lineHeight: 1.6 }}>
                09129373940 <br /> 09120183940 <br /> 09120903940 <br />{" "}
                09117303940 <br />
                09101753940
              </div>
            </span>

            {/* <span className=" my-1">
              <div>
                <MdPhoneInTalk className="me-2" />
                شبکه‌اجتماعی
              </div>
              <div className="mt-2">09218506693</div>
            </span>

            <span className=" my-1">
              <div>
                <MdPhoneInTalk className="me-2" />
                دفتر مرکزی
              </div>
              <div className="mt-2">01734534066-69</div>
            </span> */}
          </div>
          <div className="  d-flex logos align-items-end">
            {/* eLogo */}
            <div className="eLogo" />
            <div className="eLogo" />
            <div className="eLogo" />
            <div className="eLogo" />
          </div>
        </div>
        <div className="w-50 text-center">
          <div className="d-flex align-items-center justify-content-center height-sec">
            <img src={locLogo} style={{ width: 35, height: 45 }} />
            <div
              className="address"
              style={{ fontWeight: "bolder", lineHeight: "1.5" }}
            >
              گرگان - شهرک صنعتی آق قلا - فاز سه - خیابان تولید 4 - شرکت صدرا بی
              بافت صنعت هیرکان
            </div>
          </div>
          <a
            href={`https://www.google.com/maps/place/36%C2%B058'19.3%22N+54%C2%B026'50.4%22E/@36.9720321,54.4447584,17z/data=!3m1!4b1!4m14!1m7!3m6!1s0x3f833f735215028f:0x4519085ec01d81a5!2sAqqala,+Golestan+Province,+Iran!3b1!8m2!3d37.0141367!4d54.4506304!3m5!1s0x0:0x0!7e2!8m2!3d36.9720363!4d54.4473202`}
            className=" mx-auto  "
            target="_blank"
          >
            <img
              src={map}
              style={{ objectFit: "cover", width: "100%" }}
              className="rounded map"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
